import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';
import {alterarExibir, alterarObrigatorio, separarConfiguracoesFormulario} from '../../components/processo/processoSelecao.js';
import {tituloSecao} from '../../../../utils/styles.js';

const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    sectionTitle: {
        ...tituloSecao(theme),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    colunaCheckbox: {
        width: '120px'
    }
}));

/*
 * Aba "Formulário": quais grupos do formulário de inscrição aparecem e quais
 * são obrigatórios — numa tabela os grupos comuns e noutra os de veterano.
 * Desmarcar "Exibir" desmarca e trava "Obrigatório".
 */
export default function TabFormulario({watch, setValue}) {
    const classes = useStyles();
    const configuracoes = watch('configuracoesFormulario') || [];
    const {semVeterano, comVeterano} = separarConfiguracoesFormulario(configuracoes);

    const alterar = (indice, alteracao) => {
        const atual = [...configuracoes];
        atual[indice] = alteracao(atual[indice]);
        setValue('configuracoesFormulario', atual, {shouldDirty: true});
    };

    const colunas = [
        {label: 'Grupo', field: 'grupo', valueGetter: valor => ouTraco(valor)},
        {
            label: 'Exibir', field: 'exibir', sortable: false, className: classes.colunaCheckbox,
            valueGetter: (valor, row) => (
                <Checkbox color='primary' checked={!!row.exibir}
                          inputProps={{'aria-label': `Exibir ${row.grupo || ''}`}}
                          onChange={evento => alterar(row.indice, configuracao => alterarExibir(configuracao, evento.target.checked))}/>
            )
        },
        {
            label: 'Obrigatório', field: 'obrigatorio', sortable: false, className: classes.colunaCheckbox,
            valueGetter: (valor, row) => (
                <Checkbox color='primary' checked={!!row.obrigatorio} disabled={!row.exibir}
                          inputProps={{'aria-label': `Obrigatório ${row.grupo || ''}`}}
                          onChange={evento => alterar(row.indice, configuracao => alterarObrigatorio(configuracao, evento.target.checked))}/>
            )
        }
    ];

    const tabela = (titulo, linhas) => (
        <Grid item xs={12} md={6}>
            <h4 className={classes.sectionTitle}>{titulo}</h4>
            <DataGrid
                rows={linhas}
                columns={colunas}
                tableContainerProps={TABLE_CONTAINER_PROPS}
                noRecordsText='Não existe grupos definidos para formulário.'/>
        </Grid>
    );

    return (
        <Grid container spacing={3}>
            {tabela('Configurar exibição dos grupos no formulário', semVeterano)}
            {tabela('Configurar exibição dos grupos de veterano no formulário', comVeterano)}
        </Grid>
    );
}

TabFormulario.propTypes = {
    watch: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired
};
